import { render } from "./ResumedCharts.vue?vue&type=template&id=2319da37"
import script from "./ResumedCharts.vue?vue&type=script&lang=js"
export * from "./ResumedCharts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__